import { ref } from "vue";
import { AppConstants } from "@/constants/AppConstants";
import { AxiosError } from "axios";
import messages from "@/assets/messages.json";
import apiClientAuth from "@/util/apiClientAuth";
interface IncentiveItem {
  isIncentiveEntry: boolean;
}

const item = ref<IncentiveItem>({
  isIncentiveEntry: false, // 奨励表彰エントリー状態
});
const errorMessage = ref<string | null>(null);

function saveToLocalStorage(item: IncentiveItem): void {
  localStorage.setItem(
    AppConstants.INCENTIVE_INFO_SESSION_NAME,
    JSON.stringify(item)
  );
}

export function useIncentiveStore() {
  /**
   * インセンティブのエントリー状態などを取得、保持します。
   * @param {string} agcode -AGコード
   * @param {string} userId -ユーザーID
   * @returns {Promise<string | null>} エラーが発生した場合はエラーメッセージを含む文字列、正常に取得できた場合は null を返す Promise。
   */
  async function fetchIncentiveFromAPI(
    agcode: string,
    userId: string
  ): Promise<string | null> {
    try {
      const response = await apiClientAuth.post(
        "/api/Incentive/getIncentiveInfo",
        {
          systemKbn: process.env.VUE_APP_SYSTEM_KBN,
          agCode: agcode,
          userId: userId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      // 取得したデータでストアの項目を更新する
      item.value = response.data;
      // 取得した項目をローカルストレージに保存する
      saveToLocalStorage(item.value);

      // 前回のエラーメッセージをクリアする
      errorMessage.value = null;

      // エラーが発生しなかったことを示すために null を返す
      return null;
    } catch (error) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        switch (axiosError.response.status) {
          case 401:
            errorMessage.value = messages.ERR_USER002;
            break;
          case 500:
            errorMessage.value = messages.ERR_SYS999;
            break;
          default:
            errorMessage.value = messages.ERR_SYS001;
        }
      } else if (axiosError.request) {
        errorMessage.value = messages.ERR_SYS001;
      } else {
        errorMessage.value = messages.ERR_SYS002;
        if (process.env.VUE_APP_DEBUG === "true") {
          console.log("Error: ", axiosError.message);
        }
      }

      return errorMessage.value;
    }
  }

  return {
    fetchIncentiveFromAPI,
    errorMessage,
  };
}
